export const fetchSize = sizeString => {
  if (!sizeString) {
    return ""
  }
  if (sizeString.split(" ").length > 1 || !parseFloat(sizeString)) {
    return sizeString
  } else if (new RegExp("mm$").test(sizeString)) {
    return (
      parseFloat(sizeString).toString() +
      '<span style="font-size: 10px;">mm</span>'
    )
  } else {
    return parseFloat(sizeString)
  }
}
